import React, { SVGProps } from 'react';

export const RevenueIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 30,
  height = 30,
  fill = '#0063D6',
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 30 30"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.0625 9.80875C12.8925 10.1287 12.1875 11.0275 12.1875 11.875C12.1875 12.7225 12.8925 13.6212 14.0625 13.94V9.80875ZM15.9375 16.06V20.19C17.1075 19.8712 17.8125 18.9725 17.8125 18.125C17.8125 17.2775 17.1075 16.3787 15.9375 16.06Z"
        fill={fill}
      />
      <path
        clipRule="evenodd"
        d="M27.5 15C27.5 21.9037 21.9037 27.5 15 27.5C8.09625 27.5 2.5 21.9037 2.5 15C2.5 8.09625 8.09625 2.5 15 2.5C21.9037 2.5 27.5 8.09625 27.5 15ZM15 6.5625C15.2486 6.5625 15.4871 6.66127 15.6629 6.83709C15.8387 7.0129 15.9375 7.25136 15.9375 7.5V7.89625C17.975 8.26125 19.6875 9.7925 19.6875 11.875C19.6875 12.1236 19.5887 12.3621 19.4129 12.5379C19.2371 12.7137 18.9986 12.8125 18.75 12.8125C18.5014 12.8125 18.2629 12.7137 18.0871 12.5379C17.9113 12.3621 17.8125 12.1236 17.8125 11.875C17.8125 11.0275 17.1075 10.1288 15.9375 9.80875V14.1463C17.975 14.5113 19.6875 16.0425 19.6875 18.125C19.6875 20.2075 17.975 21.7388 15.9375 22.1038V22.5C15.9375 22.7486 15.8387 22.9871 15.6629 23.1629C15.4871 23.3387 15.2486 23.4375 15 23.4375C14.7514 23.4375 14.5129 23.3387 14.3371 23.1629C14.1613 22.9871 14.0625 22.7486 14.0625 22.5V22.1038C12.025 21.7388 10.3125 20.2075 10.3125 18.125C10.3125 17.8764 10.4113 17.6379 10.5871 17.4621C10.7629 17.2863 11.0014 17.1875 11.25 17.1875C11.4986 17.1875 11.7371 17.2863 11.9129 17.4621C12.0887 17.6379 12.1875 17.8764 12.1875 18.125C12.1875 18.9725 12.8925 19.8713 14.0625 20.19V15.8537C12.025 15.4887 10.3125 13.9575 10.3125 11.875C10.3125 9.7925 12.025 8.26125 14.0625 7.89625V7.5C14.0625 7.25136 14.1613 7.0129 14.3371 6.83709C14.5129 6.66127 14.7514 6.5625 15 6.5625Z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  );
};
